/**
 * Тумблер тепловой карты плотности точечных фич доски.
 */
import { useEffect, useState } from "react";
import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { dispatchTacticalHeatmapOverlay } from "@/lib/tactical-heatmap-map-bridge";
import type { TacticalFeature, TacticalTrack } from "@/services/tactical.service";
import { buildTacticalHeatmapPoints } from "@/tactical/heatmap/buildHeatmapPoints";

type Props = {
  features: TacticalFeature[];
  tracks: TacticalTrack[];
};

export function TacticalHeatmapPanel({ features, tracks }: Props) {
  const [enabled, setEnabled] = useState(false);
  const [includeTracks, setIncludeTracks] = useState(false);

  useEffect(() => {
    if (!enabled) {
      dispatchTacticalHeatmapOverlay(null);
      return;
    }
    const { featureCollection } = buildTacticalHeatmapPoints({
      features,
      tracks,
      includeTrackHeads: includeTracks,
    });
    dispatchTacticalHeatmapOverlay(
      featureCollection.features.length > 0 ? featureCollection : null,
    );
  }, [enabled, includeTracks, features, tracks]);

  useEffect(() => {
    return () => {
      dispatchTacticalHeatmapOverlay(null);
    };
  }, []);

  return (
    <div className="space-y-2 border-t pt-2">
      <div className="flex items-center gap-1 px-1">
        <p className="text-xs font-medium text-muted-foreground">Тепловая карта</p>
        <SectionHelpTooltip label="Справка: тепловая карта доски">
          <p>
            Обзорная плотность точечных знаков и подписей на текущей доске (MapLibre heatmap).
          </p>
          <ul className="list-disc space-y-1 pl-4">
            <li>Участвуют фичи kind point и text; линии/полигоны — нет.</li>
            <li>Опционально — головы видимых треков.</li>
            <li>Не анимация истории (time-lapse) и не справочный оверлей GeoServer.</li>
            <li>Слой не создаёт фичи и не мешает выбору объектов COP.</li>
          </ul>
        </SectionHelpTooltip>
      </div>
      <div className="flex items-center justify-between gap-2 px-1">
        <Label className="cursor-pointer text-xs">Показать плотность</Label>
        <Switch
          checked={enabled}
          onCheckedChange={setEnabled}
          aria-label="Тепловая карта"
        />
      </div>
      {enabled && (
        <div className="flex items-center justify-between gap-2 px-1">
          <Label className="cursor-pointer text-xs text-muted-foreground">
            + головы треков
          </Label>
          <Switch
            checked={includeTracks}
            onCheckedChange={setIncludeTracks}
            aria-label="Включить головы треков в heatmap"
          />
        </div>
      )}
    </div>
  );
}
